import { gql } from '@apollo/client';

interface GetEnvironmentAssumeRoleUrlProps {
    environmentUri: string;
    currentRole: string;
    currentAccount: string;
    currentBucket?: string;
    currentPrefix?: string;
}
const getEnvironmentAssumeRoleUrl = ({
    environmentUri,
    currentRole,
    currentAccount,
    currentBucket,
    currentPrefix,
}: GetEnvironmentAssumeRoleUrlProps) => {
    return {
        variables: {
            environmentUri,
            currentRole,
            currentAccount,
            currentBucket,
            currentPrefix,
        },
        query: gql`
            query GetEnvironmentAssumeRoleUrl(
                $environmentUri: String
                $currentRole: String
                $currentAccount: String
                $currentBucket: String
                $currentPrefix: String
            ) {
                getEnvironmentAssumeRoleUrl(
                    environmentUri: $environmentUri
                    currentRole: $currentRole
                    currentAccount: $currentAccount
                    currentBucket: $currentBucket
                    currentPrefix: $currentPrefix
                )
            }
        `,
    };
};

export default getEnvironmentAssumeRoleUrl;
